module.exports = __webpack_public_path__ + "b6337a6b35be9144c95bde3ebf1cf377.png";